export default __webpack_public_path__ + "static/media/bg-cover2.e683c5bb.png";